/** MEMORY_BLACK_WATER — the Xingtang sickroom, 万千梅's triangle. */
import type { DialogueData } from '@/core/types/contracts';
import { SPEAKER } from '../actors';
import { letter, linear, narr, say } from './util';

export const BLACK_WATER_DIALOGUES: DialogueData[] = [
  linear('prologue-water-intro', [
    letter('那天我病了────不知道什么病，吃了那些草药也没有用。'),
    narr('后来他们请来村里的万千梅婆婆。'),
    say(SPEAKER.wanqianmei, '都出去。'),
  ]),
  linear('prologue-water-door', [
    narr('婆婆把大家全都赶了出去，然后关上了门。'),
    say(SPEAKER.wanqianmei, '……', { emotion: 'chant' }),
    narr('她对着我念了一句听不懂的话，在地上画了一个三角形的法阵。'),
  ]),
  linear('prologue-water-gaze', [
    narr('忽然间，三角形的上方出现了一个黑色的三角形。'),
    say(SPEAKER.wanqianmei, '盯着看。你看见什么了？'),
  ]),
  linear('prologue-water-nothing', [
    say(SPEAKER.jiang, '……什么也没有。头好痛……', { emotion: 'pain' }),
    say(SPEAKER.wanqianmei, '接着看。'),
  ]),
  linear('prologue-water-vision', [
    narr('好多水。好多好多黑色的水，不断向外涌出。'),
    say(SPEAKER.jiang, '我看见好多水，好多黑色的水。', { emotion: 'eyes-closed' }),
    narr('婆婆半天没有吭声。'),
    narr('我睁眼看她，她眉头紧缩。'),
    letter('你知道的，婆婆平时是很慈祥的，很少见她有特殊的情绪。'),
    say(SPEAKER.jiang, '婆婆……怎么了？'),
    narr('婆婆只是深深地看着我。'),
    say(SPEAKER.wanqianmei, '江子潮，你很快就会没事。但是，需要一点点药材。你去南陆吧，那里有你的答案。', { emotion: 'grave' }),
  ]),
];
